import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route } from 'react-router-dom'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import './containers/index.css'
import App from './containers/App'
import reducer from './reducers/index'
import { MuiThemeProvider } from '@material-ui/core/'
import { MuiPickersUtilsProvider } from 'material-ui-pickers'
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils'
import * as Sentry from '@sentry/react'
import * as FullStory from '@fullstory/browser'
import { Integrations } from '@sentry/tracing'
import { theme } from 'constants/theme'
import GlobalStyle from './globalStyles'
import Clarity from '@microsoft/clarity'
import { installFetchInterceptor } from './services/fetchInterceptor'
import { consumeQcsHandoffLogoutReturn } from './tabs/authorization/helpers/qcsHandoffSession'
import { getQcsHandoffId } from './tabs/authorization/helpers/getQcsHandoffId'
import { QCS_LOGIN_URL } from './configs'

const sentryReduxEnhancer = Sentry.createReduxEnhancer({})
export const store = createStore(reducer, sentryReduxEnhancer)

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV4Instrumentation(history),
      }),
    ],
    tracesSampleRate: 0,
  })
}

if (process.env.REACT_APP_FULL_STORY_ORG_ID) {
  FullStory.init({ orgId: process.env.REACT_APP_FULL_STORY_ORG_ID })
}

if (process.env.REACT_APP_MICROSOFT_CLARITY_PROJECT_ID) {
  Clarity.init(process.env.REACT_APP_MICROSOFT_CLARITY_PROJECT_ID)
}

// Global 401 handling: a single fetch wrapper logs the user out on any expired
// session, regardless of how individual api calls handle the response.
installFetchInterceptor()

// Back from a handoff user's Auth0 logout: rendering would start the silent
// Auth0 sign-in or show the admin login, so go straight on to QCS. A fresh
// handoff link always signs in, even right after a handoff logout.
const returningFromHandoffLogout = consumeQcsHandoffLogoutReturn()
if (returningFromHandoffLogout && !getQcsHandoffId(window.location)) {
  window.location.replace(QCS_LOGIN_URL)
} else {
  ReactDOM.render(
    <Provider store={store}>
      <GlobalStyle />
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <BrowserRouter>
          <MuiThemeProvider theme={theme}>
            <Route path="/" component={App} />
          </MuiThemeProvider>
        </BrowserRouter>
      </MuiPickersUtilsProvider>
    </Provider>,

    document.getElementById('root') || document.createElement('div'),
  )
}
